// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonthCalendar_monthContainer__cDPF5{
    margin: 0 auto;
}
.MonthCalendar_monthCalendarTableContainer__puNsF {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    max-width: 500px;
    margin: 0 auto;
}
.MonthCalendar_calendarMonthWeekDayItem__C\\+Lb6 {
    text-align: center;
    margin: 0;
    padding: 10px 5px;
    font-size: 14px;
    font-weight: normal;
}
.MonthCalendar_day__dTyan{
    margin: 0;
    padding: 0;
    border: 1px solid var(--color-103);
}

.MonthCalendar_prevMonthDay__81jC4 .MonthCalendar_standardCalendarDayContent__uv1W1,
.MonthCalendar_nextMonthDay__8IedK .MonthCalendar_standardCalendarDayContent__uv1W1{
    background: var(--color-110);
}
.MonthCalendar_standardCalendarDayContent__uv1W1 {
    padding: 10px;
    height: 80px;
    box-sizing: border-box;
}
.MonthCalendar_today__ZEAAu .MonthCalendar_standardCalendarDayContent__uv1W1{
    -webkit-box-shadow: inset 0 0 0 2px var(--color-201);
    -moz-box-shadow: inset 0 0 0 2px var(--color-201);
    box-shadow: inset 0 0 0 2px var(--color-201);
}
.MonthCalendar_calendarMonthWeekDaysHeader__yhwmj{

}
.MonthCalendar_week__MtrJq {

}
.MonthCalendar_pastMonth__B3O7N,
.MonthCalendar_futureMonth__67t6p {

}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Calendar/MonthCalendar.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,UAAU;IACV,kCAAkC;AACtC;;AAEA;;IAEI,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,oDAAoD;IACpD,iDAAiD;IACjD,4CAA4C;AAChD;AACA;;AAEA;AACA;;AAEA;AACA;;;AAGA","sourcesContent":[".monthContainer{\n    margin: 0 auto;\n}\n.monthCalendarTableContainer {\n    table-layout: fixed;\n    width: 100%;\n    border-collapse: collapse;\n    max-width: 500px;\n    margin: 0 auto;\n}\n.calendarMonthWeekDayItem {\n    text-align: center;\n    margin: 0;\n    padding: 10px 5px;\n    font-size: 14px;\n    font-weight: normal;\n}\n.day{\n    margin: 0;\n    padding: 0;\n    border: 1px solid var(--color-103);\n}\n\n.prevMonthDay .standardCalendarDayContent,\n.nextMonthDay .standardCalendarDayContent{\n    background: var(--color-110);\n}\n.standardCalendarDayContent {\n    padding: 10px;\n    height: 80px;\n    box-sizing: border-box;\n}\n.today .standardCalendarDayContent{\n    -webkit-box-shadow: inset 0 0 0 2px var(--color-201);\n    -moz-box-shadow: inset 0 0 0 2px var(--color-201);\n    box-shadow: inset 0 0 0 2px var(--color-201);\n}\n.calendarMonthWeekDaysHeader{\n\n}\n.week {\n\n}\n.pastMonth,\n.futureMonth {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monthContainer": `MonthCalendar_monthContainer__cDPF5`,
	"monthCalendarTableContainer": `MonthCalendar_monthCalendarTableContainer__puNsF`,
	"calendarMonthWeekDayItem": `MonthCalendar_calendarMonthWeekDayItem__C+Lb6`,
	"day": `MonthCalendar_day__dTyan`,
	"prevMonthDay": `MonthCalendar_prevMonthDay__81jC4`,
	"standardCalendarDayContent": `MonthCalendar_standardCalendarDayContent__uv1W1`,
	"nextMonthDay": `MonthCalendar_nextMonthDay__8IedK`,
	"today": `MonthCalendar_today__ZEAAu`,
	"calendarMonthWeekDaysHeader": `MonthCalendar_calendarMonthWeekDaysHeader__yhwmj`,
	"week": `MonthCalendar_week__MtrJq`,
	"pastMonth": `MonthCalendar_pastMonth__B3O7N`,
	"futureMonth": `MonthCalendar_futureMonth__67t6p`
};
export default ___CSS_LOADER_EXPORT___;
